module.exports = __webpack_public_path__ + "static/media/LOOT.f028d398.png";